import { AppName, getState, PathChangedEvent } from '@amzn/DMWebEventBus';
import { VIDEO_STORIES_OVERLAY_TEMPLATE } from '../types/templates/videoStoriesOverlay';
import { CREATE_TEMPLATE, enqueueSkyfireMethod, REMOVE_TEMPLATE } from '../actions';
import { RETAIL_PLAYER_DP_ASIN_REGEX_PATH, RETAIL_PLAYER_DP_ASIN_REGEX_REPLACE, RETAIL_PLAYER_PATH_SUBSTR_REGEX_EXP, } from '../constants/retailPlayerConstants';
import { CHROME_TEMPLATE } from '../types/templates/chrome';
import { getParameterByName, getSkyfireEnvironment, globals } from '../utils';
import { getGenericErrorDialogMethod } from './genericErrorDialog';
import { isRetailPlayerRequest } from './retailPlayerHelper';
import { SET_VIDEO_STORIES_INDEX, SET_VIDEO_STORIES_MEDIA_EVENTS, SET_VIDEO_STORIES_TEMPLATE_QUEUE, } from '../actions/VideoStory';
import { VIDEO_STORY_PLAYBACK_TEMPLATE } from '../types/templates/videoStoryPlayback';
// add create template method
export function createOverlayTemplate() {
    return {
        interface: CREATE_TEMPLATE,
        template: {
            interface: VIDEO_STORIES_OVERLAY_TEMPLATE,
        },
        forced: false,
        owner: 'me',
        queue: {
            interface: 'QueuesInterface.v1_0.SingleThreadedQueue',
            id: 'TEMPLATE',
        },
    };
}
export function getVideoStoriesMediaForVideoStoriesSkill() {
    // storyAsins: string[],
    return [
        {
            interface: CREATE_TEMPLATE,
            template: {
                interface: VIDEO_STORIES_OVERLAY_TEMPLATE,
            },
            forced: false,
            owner: 'me',
            queue: {
                interface: 'QueuesInterface.v1_0.SingleThreadedQueue',
                id: 'TEMPLATE',
            },
        },
        // {
        //     interface: SET_VIDEO_STORIES_INDEX,
        //     currentTemplateIndex: 0,
        //     forced: false,
        //     owner: 'me',
        //     queue: {
        //         interface: 'QueuesInterface.v1_0.SingleThreadedQueue',
        //         id: 'TEMPLATE',
        //     }
        // },
        {
            interface: SET_VIDEO_STORIES_TEMPLATE_QUEUE,
            videoStoryTemplateQueue: [
                // //////////////////// VS1 ////////////////////////
                {
                    interface: VIDEO_STORY_PLAYBACK_TEMPLATE,
                    playbackURL: 'https://video-story.mvas.music.amazon.dev/com.amazon.playback.object.vod.0D0F4ED8-1551-40C7-BCEF-6B5342508277.mpd',
                    asin: 'B0C49FR89Z',
                    pid: 'com.amazon.playback.object.vod.0D0F4ED8-1551-40C7-BCEF-6B5342508277',
                    posterUrl: 'https://m.media-amazon.com/images/I/419yRaXomKL.jpg',
                    title: 'Beginnings',
                    durationSeconds: 50,
                    artistInfo: {
                        interface: 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.CircleHorizontalItemElement',
                        primaryText: {
                            interface: 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.TextElement',
                            text: 'TWICE',
                            disabled: false,
                        },
                        image: 'https://m.media-amazon.com/images/I/51C4p+YoS-L.jpg',
                        imageAltText: 'TWICE',
                        tags: [],
                        showNavigationIcon: false,
                        isCompressed: false,
                        isFeatured: false,
                        isLocked: false,
                        isActive: false,
                        isDisabled: false,
                    },
                    pillNavigator: {
                        interface: 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.PillNavigatorItemElement',
                        text: 'Watch more on the app',
                        onItemSelected: [],
                        primaryLink: {
                            interface: 'Web.PageInterface.v1_0.LinkElement',
                            onItemSelected: [
                                {
                                    interface: 'InteractionInterface.v1_0.GlobalInvokeHttpSkillMethod',
                                    url: 'https://na.mesk.skill.music.a2z.com/api/elementClicked?info=%7B%22action%22%3A%22DOWNLOAD_BUTTON_VIDEO_STORY_MAI_CLICK%22%2C%22pageType%22%3A%22NOW_PLAYING_VIDEO_STORY%22%2C%22interactionType%22%3Anull%2C%22metricsToken%22%3A%22%7B%5C%22contentInfo%5C%22%3A%5C%22%7B%5C%5C%5C%22source%5C%5C%5C%22%3A%5C%5C%5C%22client%5C%5C%5C%22%2C%5C%5C%5C%22id%5C%5C%5C%22%3A%5C%5C%5C%22B0C49FR89Z%5C%5C%5C%22%2C%5C%5C%5C%22contentName%5C%5C%5C%22%3A%5C%5C%5C%22videoStoryPlayback%5C%5C%5C%22%2C%5C%5C%5C%22blockRef%5C%5C%5C%22%3Anull%2C%5C%5C%5C%22containerIndex%5C%5C%5C%22%3Anull%2C%5C%5C%5C%22accessibleItemCount%5C%5C%5C%22%3Anull%2C%5C%5C%5C%22firstViewableIndex%5C%5C%5C%22%3Anull%2C%5C%5C%5C%22lastViewableIndex%5C%5C%5C%22%3Anull%2C%5C%5C%5C%22localContentId%5C%5C%5C%22%3Anull%2C%5C%5C%5C%22reasonType%5C%5C%5C%22%3Anull%2C%5C%5C%5C%22selected%5C%5C%5C%22%3Anull%2C%5C%5C%5C%22filter%5C%5C%5C%22%3Anull%7D%5C%22%2C%5C%22entityId%5C%22%3A%5C%22B0C49FR89Z%5C%22%2C%5C%22entityIdType%5C%22%3A%5C%22ASIN%5C%22%2C%5C%22entityType%5C%22%3A%5C%22VIDEO_STORY%5C%22%7D%22%2C%22blockRef%22%3Anull%2C%22refMarker%22%3A%22%22%2C%22target%22%3Anull%2C%22localContentId%22%3Anull%7D&userHash=%7B%22level%22%3A%22FREE_MEMBER%22%7D',
                                    clientInformation: [],
                                    before: [],
                                    after: [],
                                    onSuccess: [],
                                    onError: [],
                                    queue: {
                                        interface: 'QueuesInterface.v1_0.MultiThreadedQueue',
                                        id: 'MT_HTTP',
                                    },
                                    forced: false,
                                },
                                {
                                    interface: 'TemplateListInterface.v1_0.CreateTemplateMethod',
                                    template: {
                                        interface: 'Web.TemplatesInterface.v1_0.Touch.DialogTemplateInterface.DialogTemplate',
                                        header: 'Listen on the go',
                                        columns: [
                                            {
                                                interface: 'Web.TemplatesInterface.v1_0.Touch.DialogTemplateInterface.DialogColumnTemplate',
                                                buttons: [],
                                                header: 'Scan to download the Amazon Music mobile app on your phone',
                                                image: 'https://m.media-amazon.com/images/G/01/onramp_qrcode/AmazonMusicUSTwiceQR.png',
                                                imageAltText: 'Scan to download the Amazon Music mobile app on your phone: https://musicapp.amazon.com/artists/B0011XQAXQ?story=B0C49FR89Z',
                                                onCreated: [],
                                                onBound: [],
                                                onViewed: [],
                                                onInteraction: [],
                                                onLeave: [],
                                                launchMode: 'standard',
                                                cacheSeconds: 9223372036854775807,
                                            },
                                        ],
                                        closeButton: {
                                            interface: 'Web.TemplatesInterface.v1_0.Touch.DialogTemplateInterface.DialogCloseButtonElement',
                                            altText: 'Dismiss',
                                            icon: 'cancel',
                                            primaryLink: {
                                                interface: 'Web.PageInterface.v1_0.LinkElement',
                                                onItemSelected: [
                                                    {
                                                        interface: 'InteractionInterface.v1_0.GlobalInvokeHttpSkillMethod',
                                                        url: 'https://na.mesk.skill.music.a2z.com/api/elementClicked?info=%7B%22action%22%3A%22NO_THANKS_DOWNLOAD_MOBILE_APP_BUTTON_CLICK%22%2C%22pageType%22%3Anull%2C%22interactionType%22%3A%22CLICK%22%2C%22metricsToken%22%3A%22%7B%5C%22contentInfo%5C%22%3A%5C%22%7B%5C%5C%5C%22source%5C%5C%5C%22%3A%5C%5C%5C%22client%5C%5C%5C%22%2C%5C%5C%5C%22id%5C%5C%5C%22%3Anull%2C%5C%5C%5C%22contentName%5C%5C%5C%22%3A%5C%5C%5C%22videoStoryMAI%5C%5C%5C%22%2C%5C%5C%5C%22blockRef%5C%5C%5C%22%3Anull%2C%5C%5C%5C%22containerIndex%5C%5C%5C%22%3A0%2C%5C%5C%5C%22accessibleItemCount%5C%5C%5C%22%3A0%2C%5C%5C%5C%22firstViewableIndex%5C%5C%5C%22%3A0%2C%5C%5C%5C%22lastViewableIndex%5C%5C%5C%22%3A0%2C%5C%5C%5C%22localContentId%5C%5C%5C%22%3Anull%2C%5C%5C%5C%22reasonType%5C%5C%5C%22%3Anull%2C%5C%5C%5C%22selected%5C%5C%5C%22%3Anull%2C%5C%5C%5C%22filter%5C%5C%5C%22%3Anull%7D%5C%22%7D%22%2C%22blockRef%22%3Anull%2C%22refMarker%22%3A%22dmm_aud_pop_us_na_twice_oo_qr_vs%22%2C%22target%22%3Anull%2C%22localContentId%22%3Anull%7D&userHash=%7B%22level%22%3A%22FREE_MEMBER%22%7D',
                                                        clientInformation: [],
                                                        before: [],
                                                        after: [],
                                                        onSuccess: [],
                                                        onError: [],
                                                        queue: {
                                                            interface: 'QueuesInterface.v1_0.MultiThreadedQueue',
                                                            id: 'MT_HTTP',
                                                        },
                                                        forced: false,
                                                    },
                                                    {
                                                        interface: 'TemplateListInterface.v1_0.RemoveTemplateMethod',
                                                        queue: {
                                                            interface: 'QueuesInterface.v1_0.SingleThreadedQueue',
                                                            id: 'TEMPLATE',
                                                        },
                                                        forced: false,
                                                    },
                                                ],
                                            },
                                        },
                                        onCreated: [],
                                        onBound: [],
                                        onViewed: [],
                                        onInteraction: [],
                                        onLeave: [],
                                        launchMode: 'standard',
                                        cacheSeconds: 9223372036854775807,
                                    },
                                    screenMode: 'templateShard',
                                    queue: {
                                        interface: 'QueuesInterface.v1_0.SingleThreadedQueue',
                                        id: 'TEMPLATE',
                                    },
                                    forced: false,
                                },
                            ],
                        },
                    },
                    logo: 'https://m.media-amazon.com/images/G/01/music-tv/music_logo._SX260_SY50_BL0_QL100_FMpng_.png',
                    autoPlay: true,
                    onStarted: [],
                    onResumed: [],
                    onPaused: [],
                    onFinished: [
                        {
                            interface: SET_VIDEO_STORIES_INDEX,
                            currentTemplateIndex: 1,
                            forced: false,
                            owner: 'me',
                            queue: {
                                interface: 'QueuesInterface.v1_0.SingleThreadedQueue',
                                id: 'TEMPLATE',
                            },
                        },
                    ],
                    onStopped: [],
                    onError: [],
                    onCreated: [],
                    onInteraction: [
                        {
                            interface: 'InteractionInterface.v1_0.GlobalInvokeHttpSkillMethod',
                            url: 'https://na.mesk.skill.music.a2z.com/api/elementClicked?info=%7B%22action%22%3A%22PLAY_PAUSE_VIDEO_STORY%22%2C%22pageType%22%3A%22NOW_PLAYING_VIDEO_STORY%22%2C%22interactionType%22%3Anull%2C%22metricsToken%22%3A%22%22%2C%22blockRef%22%3Anull%2C%22refMarker%22%3A%22%22%2C%22target%22%3Anull%2C%22localContentId%22%3Anull%7D&userHash=%7B%22level%22%3A%22FREE_MEMBER%22%7D',
                            clientInformation: [],
                            before: [],
                            after: [],
                            onSuccess: [],
                            onError: [],
                            queue: {
                                interface: 'QueuesInterface.v1_0.MultiThreadedQueue',
                                id: 'MT_HTTP',
                            },
                            forced: false,
                        },
                    ],
                    onLeave: [],
                    launchMode: 'standard',
                    cacheSeconds: 9223372036854775807,
                    onViewed: [
                        {
                            interface: SET_VIDEO_STORIES_MEDIA_EVENTS,
                            forced: false,
                            owner: 'me',
                            onNavigateToNext: [
                                {
                                    interface: SET_VIDEO_STORIES_INDEX,
                                    currentTemplateIndex: 1,
                                    forced: false,
                                    owner: 'me',
                                    queue: {
                                        interface: 'QueuesInterface.v1_0.SingleThreadedQueue',
                                        id: 'TEMPLATE',
                                    },
                                },
                            ],
                            onNavigateToPrevious: [
                            // {
                            //     interface: SET_VIDEO_STORIES_INDEX,
                            //     currentTemplateIndex
                            // }
                            ],
                            onClose: [
                            // {
                            //     interface: REMOVE_TEMPLATE,
                            //     forced: false,
                            //     owner: 'me',
                            // }
                            ],
                            queue: {
                                interface: 'QueuesInterface.v1_0.MultiThreadedQueue',
                                id: 'MT_HTTP',
                            },
                        },
                    ],
                },
                // //////////////////// VS2 ////////////////////////
                {
                    interface: VIDEO_STORY_PLAYBACK_TEMPLATE,
                    playbackURL: 'https://video-story.mvas.music.amazon.dev/com.amazon.playback.object.vod.3B2DBDD3-3DF6-44F6-A9F7-8DE8E66D65A6.mpd',
                    asin: 'B0C4348JXR',
                    pid: 'com.amazon.playback.object.vod.3B2DBDD3-3DF6-44F6-A9F7-8DE8E66D65A6',
                    posterUrl: 'https://m.media-amazon.com/images/I/41zJ+eutRdL.jpg',
                    title: 'Becky Hill on her first performance at age 11',
                    durationSeconds: 105,
                    artistInfo: {
                        interface: 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.CircleHorizontalItemElement',
                        primaryText: {
                            interface: 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.TextElement',
                            text: 'Becky Hill',
                            disabled: false,
                        },
                        image: 'https://m.media-amazon.com/images/I/913q3lb+qSL.jpg',
                        imageAltText: 'Becky Hill',
                        tags: [],
                        showNavigationIcon: false,
                        isCompressed: false,
                        isFeatured: false,
                        isLocked: false,
                        isActive: false,
                        isDisabled: false,
                    },
                    pillNavigator: {
                        interface: 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.PillNavigatorItemElement',
                        text: 'Watch more on the app',
                        onItemSelected: [],
                        primaryLink: {
                            interface: 'Web.PageInterface.v1_0.LinkElement',
                            onItemSelected: [
                                {
                                    interface: 'InteractionInterface.v1_0.GlobalInvokeHttpSkillMethod',
                                    url: 'https://na.mesk.skill.music.a2z.com/api/elementClicked?info=%7B%22action%22%3A%22DOWNLOAD_BUTTON_VIDEO_STORY_MAI_CLICK%22%2C%22pageType%22%3A%22NOW_PLAYING_VIDEO_STORY%22%2C%22interactionType%22%3Anull%2C%22metricsToken%22%3A%22%7B%5C%22contentInfo%5C%22%3A%5C%22%7B%5C%5C%5C%22source%5C%5C%5C%22%3A%5C%5C%5C%22client%5C%5C%5C%22%2C%5C%5C%5C%22id%5C%5C%5C%22%3A%5C%5C%5C%22B0C4348JXR%5C%5C%5C%22%2C%5C%5C%5C%22contentName%5C%5C%5C%22%3A%5C%5C%5C%22videoStoryPlayback%5C%5C%5C%22%2C%5C%5C%5C%22blockRef%5C%5C%5C%22%3Anull%2C%5C%5C%5C%22containerIndex%5C%5C%5C%22%3Anull%2C%5C%5C%5C%22accessibleItemCount%5C%5C%5C%22%3Anull%2C%5C%5C%5C%22firstViewableIndex%5C%5C%5C%22%3Anull%2C%5C%5C%5C%22lastViewableIndex%5C%5C%5C%22%3Anull%2C%5C%5C%5C%22localContentId%5C%5C%5C%22%3Anull%2C%5C%5C%5C%22reasonType%5C%5C%5C%22%3Anull%2C%5C%5C%5C%22selected%5C%5C%5C%22%3Anull%2C%5C%5C%5C%22filter%5C%5C%5C%22%3Anull%7D%5C%22%2C%5C%22entityId%5C%22%3A%5C%22B0C4348JXR%5C%22%2C%5C%22entityIdType%5C%22%3A%5C%22ASIN%5C%22%2C%5C%22entityType%5C%22%3A%5C%22VIDEO_STORY%5C%22%7D%22%2C%22blockRef%22%3Anull%2C%22refMarker%22%3A%22%22%2C%22target%22%3Anull%2C%22localContentId%22%3Anull%7D&userHash=%7B%22level%22%3A%22FREE_MEMBER%22%7D',
                                    clientInformation: [],
                                    before: [],
                                    after: [],
                                    onSuccess: [],
                                    onError: [],
                                    queue: {
                                        interface: 'QueuesInterface.v1_0.MultiThreadedQueue',
                                        id: 'MT_HTTP',
                                    },
                                    forced: false,
                                },
                                {
                                    interface: 'TemplateListInterface.v1_0.CreateTemplateMethod',
                                    template: {
                                        interface: 'Web.TemplatesInterface.v1_0.Touch.DialogTemplateInterface.DialogTemplate',
                                        header: 'Listen on the go',
                                        columns: [
                                            {
                                                interface: 'Web.TemplatesInterface.v1_0.Touch.DialogTemplateInterface.DialogColumnTemplate',
                                                buttons: [],
                                                header: 'Scan to download the Amazon Music mobile app on your phone',
                                                image: 'https://m.media-amazon.com/images/G/01/onramp_qrcode/AmazonMusicUSTwiceQR.png',
                                                imageAltText: 'Scan to download the Amazon Music mobile app on your phone: https://musicapp.amazon.com/live/events/L9BKQMD4UU',
                                                onCreated: [],
                                                onBound: [],
                                                onViewed: [],
                                                onInteraction: [],
                                                onLeave: [],
                                                launchMode: 'standard',
                                                cacheSeconds: 9223372036854775807,
                                            },
                                        ],
                                        closeButton: {
                                            interface: 'Web.TemplatesInterface.v1_0.Touch.DialogTemplateInterface.DialogCloseButtonElement',
                                            altText: 'Dismiss',
                                            icon: 'cancel',
                                            primaryLink: {
                                                interface: 'Web.PageInterface.v1_0.LinkElement',
                                                onItemSelected: [
                                                    {
                                                        interface: 'InteractionInterface.v1_0.GlobalInvokeHttpSkillMethod',
                                                        url: 'https://na.mesk.skill.music.a2z.com/api/elementClicked?info=%7B%22action%22%3A%22NO_THANKS_DOWNLOAD_MOBILE_APP_BUTTON_CLICK%22%2C%22pageType%22%3Anull%2C%22interactionType%22%3A%22CLICK%22%2C%22metricsToken%22%3A%22%7B%5C%22contentInfo%5C%22%3A%5C%22%7B%5C%5C%5C%22source%5C%5C%5C%22%3A%5C%5C%5C%22client%5C%5C%5C%22%2C%5C%5C%5C%22id%5C%5C%5C%22%3Anull%2C%5C%5C%5C%22contentName%5C%5C%5C%22%3A%5C%5C%5C%22videoStoryMAI%5C%5C%5C%22%2C%5C%5C%5C%22blockRef%5C%5C%5C%22%3Anull%2C%5C%5C%5C%22containerIndex%5C%5C%5C%22%3A0%2C%5C%5C%5C%22accessibleItemCount%5C%5C%5C%22%3A0%2C%5C%5C%5C%22firstViewableIndex%5C%5C%5C%22%3A0%2C%5C%5C%5C%22lastViewableIndex%5C%5C%5C%22%3A0%2C%5C%5C%5C%22localContentId%5C%5C%5C%22%3Anull%2C%5C%5C%5C%22reasonType%5C%5C%5C%22%3Anull%2C%5C%5C%5C%22selected%5C%5C%5C%22%3Anull%2C%5C%5C%5C%22filter%5C%5C%5C%22%3Anull%7D%5C%22%7D%22%2C%22blockRef%22%3Anull%2C%22refMarker%22%3A%22dmm_aud_pop_us_na_twice_oo_qr_vs%22%2C%22target%22%3Anull%2C%22localContentId%22%3Anull%7D&userHash=%7B%22level%22%3A%22FREE_MEMBER%22%7D',
                                                        clientInformation: [],
                                                        before: [],
                                                        after: [],
                                                        onSuccess: [],
                                                        onError: [],
                                                        queue: {
                                                            interface: 'QueuesInterface.v1_0.MultiThreadedQueue',
                                                            id: 'MT_HTTP',
                                                        },
                                                        forced: false,
                                                    },
                                                    {
                                                        interface: 'TemplateListInterface.v1_0.RemoveTemplateMethod',
                                                        queue: {
                                                            interface: 'QueuesInterface.v1_0.SingleThreadedQueue',
                                                            id: 'TEMPLATE',
                                                        },
                                                        forced: false,
                                                    },
                                                ],
                                            },
                                        },
                                        onCreated: [],
                                        onBound: [],
                                        onViewed: [],
                                        onInteraction: [],
                                        onLeave: [],
                                        launchMode: 'standard',
                                        cacheSeconds: 9223372036854775807,
                                    },
                                    screenMode: 'templateShard',
                                    queue: {
                                        interface: 'QueuesInterface.v1_0.SingleThreadedQueue',
                                        id: 'TEMPLATE',
                                    },
                                    forced: false,
                                },
                            ],
                        },
                    },
                    logo: 'https://m.media-amazon.com/images/G/01/music-tv/music_logo._SX260_SY50_BL0_QL100_FMpng_.png',
                    autoPlay: true,
                    onStarted: [],
                    onResumed: [],
                    onPaused: [],
                    onFinished: [
                        {
                            interface: SET_VIDEO_STORIES_INDEX,
                            currentTemplateIndex: 2,
                            forced: false,
                            owner: 'me',
                            queue: {
                                interface: 'QueuesInterface.v1_0.SingleThreadedQueue',
                                id: 'TEMPLATE',
                            },
                        },
                    ],
                    onStopped: [],
                    onError: [],
                    onCreated: [],
                    onInteraction: [
                        {
                            interface: 'InteractionInterface.v1_0.GlobalInvokeHttpSkillMethod',
                            url: 'https://na.mesk.skill.music.a2z.com/api/elementClicked?info=%7B%22action%22%3A%22PLAY_PAUSE_VIDEO_STORY%22%2C%22pageType%22%3A%22NOW_PLAYING_VIDEO_STORY%22%2C%22interactionType%22%3Anull%2C%22metricsToken%22%3A%22%22%2C%22blockRef%22%3Anull%2C%22refMarker%22%3A%22%22%2C%22target%22%3Anull%2C%22localContentId%22%3Anull%7D&userHash=%7B%22level%22%3A%22FREE_MEMBER%22%7D',
                            clientInformation: [],
                            before: [],
                            after: [],
                            onSuccess: [],
                            onError: [],
                            queue: {
                                interface: 'QueuesInterface.v1_0.MultiThreadedQueue',
                                id: 'MT_HTTP',
                            },
                            forced: false,
                        },
                    ],
                    onLeave: [],
                    launchMode: 'standard',
                    cacheSeconds: 9223372036854775807,
                    onViewed: [
                        {
                            interface: SET_VIDEO_STORIES_MEDIA_EVENTS,
                            forced: false,
                            owner: 'me',
                            onNavigateToNext: [
                                {
                                    interface: SET_VIDEO_STORIES_INDEX,
                                    currentTemplateIndex: 2,
                                    forced: false,
                                    owner: 'me',
                                    queue: {
                                        interface: 'QueuesInterface.v1_0.SingleThreadedQueue',
                                        id: 'TEMPLATE',
                                    },
                                },
                            ],
                            onNavigateToPrevious: [
                                {
                                    interface: SET_VIDEO_STORIES_INDEX,
                                    currentTemplateIndex: 0,
                                    forced: false,
                                    owner: 'me',
                                    queue: {
                                        interface: 'QueuesInterface.v1_0.SingleThreadedQueue',
                                        id: 'TEMPLATE',
                                    },
                                },
                            ],
                            onClose: [
                            // {
                            //     interface: REMOVE_TEMPLATE,
                            //     forced: false,
                            //     owner: 'me',
                            // }
                            ],
                            queue: {
                                interface: 'QueuesInterface.v1_0.MultiThreadedQueue',
                                id: 'MT_HTTP',
                            },
                        },
                    ],
                },
                // //////////////////// VS3 ////////////////////////
                {
                    interface: VIDEO_STORY_PLAYBACK_TEMPLATE,
                    playbackURL: 'https://video-story.mvas.music.amazon.dev/com.amazon.playback.object.vod.5EC0061C-A8BC-4DF4-AB34-EED070454C18.mpd',
                    asin: 'B0C437G9TF',
                    pid: 'com.amazon.playback.object.vod.5EC0061C-A8BC-4DF4-AB34-EED070454C18',
                    posterUrl: 'https://m.media-amazon.com/images/I/61iFZ3tBhKL.jpg',
                    title: 'Ed Sheeran and Aaron Dessner on ‘-‘ (Subtract)',
                    durationSeconds: 29,
                    artistInfo: {
                        interface: 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.CircleHorizontalItemElement',
                        primaryText: {
                            interface: 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.TextElement',
                            text: 'Ed Sheeran',
                            disabled: false,
                        },
                        image: 'https://m.media-amazon.com/images/I/81fvaMUzCdL.jpg',
                        imageAltText: 'Ed Sheeran',
                        tags: [],
                        showNavigationIcon: false,
                        isCompressed: false,
                        isFeatured: false,
                        isLocked: false,
                        isDisabled: false,
                        isActive: false,
                    },
                    pillNavigator: {
                        interface: 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.PillNavigatorItemElement',
                        text: 'Watch more on the app',
                        onItemSelected: [],
                        primaryLink: {
                            interface: 'Web.PageInterface.v1_0.LinkElement',
                            onItemSelected: [
                                {
                                    interface: 'InteractionInterface.v1_0.GlobalInvokeHttpSkillMethod',
                                    url: 'https://na.mesk.skill.music.a2z.com/api/elementClicked?info=%7B%22action%22%3A%22DOWNLOAD_BUTTON_VIDEO_STORY_MAI_CLICK%22%2C%22pageType%22%3A%22NOW_PLAYING_VIDEO_STORY%22%2C%22interactionType%22%3Anull%2C%22metricsToken%22%3A%22%7B%5C%22contentInfo%5C%22%3A%5C%22%7B%5C%5C%5C%22source%5C%5C%5C%22%3A%5C%5C%5C%22client%5C%5C%5C%22%2C%5C%5C%5C%22id%5C%5C%5C%22%3A%5C%5C%5C%22B0C49FR89Z%5C%5C%5C%22%2C%5C%5C%5C%22contentName%5C%5C%5C%22%3A%5C%5C%5C%22videoStoryPlayback%5C%5C%5C%22%2C%5C%5C%5C%22blockRef%5C%5C%5C%22%3Anull%2C%5C%5C%5C%22containerIndex%5C%5C%5C%22%3Anull%2C%5C%5C%5C%22accessibleItemCount%5C%5C%5C%22%3Anull%2C%5C%5C%5C%22firstViewableIndex%5C%5C%5C%22%3Anull%2C%5C%5C%5C%22lastViewableIndex%5C%5C%5C%22%3Anull%2C%5C%5C%5C%22localContentId%5C%5C%5C%22%3Anull%2C%5C%5C%5C%22reasonType%5C%5C%5C%22%3Anull%2C%5C%5C%5C%22selected%5C%5C%5C%22%3Anull%2C%5C%5C%5C%22filter%5C%5C%5C%22%3Anull%7D%5C%22%2C%5C%22entityId%5C%22%3A%5C%22B0C49FR89Z%5C%22%2C%5C%22entityIdType%5C%22%3A%5C%22ASIN%5C%22%2C%5C%22entityType%5C%22%3A%5C%22VIDEO_STORY%5C%22%7D%22%2C%22blockRef%22%3Anull%2C%22refMarker%22%3A%22%22%2C%22target%22%3Anull%2C%22localContentId%22%3Anull%7D&userHash=%7B%22level%22%3A%22FREE_MEMBER%22%7D',
                                    clientInformation: [],
                                    before: [],
                                    after: [],
                                    onSuccess: [],
                                    onError: [],
                                    queue: {
                                        interface: 'QueuesInterface.v1_0.MultiThreadedQueue',
                                        id: 'MT_HTTP',
                                    },
                                    forced: false,
                                },
                                {
                                    interface: 'TemplateListInterface.v1_0.CreateTemplateMethod',
                                    template: {
                                        interface: 'Web.TemplatesInterface.v1_0.Touch.DialogTemplateInterface.DialogTemplate',
                                        header: 'Listen on the go',
                                        columns: [
                                            {
                                                interface: 'Web.TemplatesInterface.v1_0.Touch.DialogTemplateInterface.DialogColumnTemplate',
                                                buttons: [],
                                                header: 'Scan to download the Amazon Music mobile app on your phone',
                                                image: 'https://m.media-amazon.com/images/G/01/onramp_qrcode/AmazonMusicUSTwiceQR.png',
                                                imageAltText: 'Scan to download the Amazon Music mobile app on your phone: https://musicapp.amazon.com/artists/B0011XQAXQ?story=B0C49FR89Z',
                                                onCreated: [],
                                                onBound: [],
                                                onViewed: [],
                                                onInteraction: [],
                                                onLeave: [],
                                                launchMode: 'standard',
                                                cacheSeconds: 9223372036854775807,
                                            },
                                        ],
                                        closeButton: {
                                            interface: 'Web.TemplatesInterface.v1_0.Touch.DialogTemplateInterface.DialogCloseButtonElement',
                                            altText: 'Dismiss',
                                            icon: 'cancel',
                                            primaryLink: {
                                                interface: 'Web.PageInterface.v1_0.LinkElement',
                                                onItemSelected: [
                                                    {
                                                        interface: 'InteractionInterface.v1_0.GlobalInvokeHttpSkillMethod',
                                                        url: 'https://na.mesk.skill.music.a2z.com/api/elementClicked?info=%7B%22action%22%3A%22NO_THANKS_DOWNLOAD_MOBILE_APP_BUTTON_CLICK%22%2C%22pageType%22%3Anull%2C%22interactionType%22%3A%22CLICK%22%2C%22metricsToken%22%3A%22%7B%5C%22contentInfo%5C%22%3A%5C%22%7B%5C%5C%5C%22source%5C%5C%5C%22%3A%5C%5C%5C%22client%5C%5C%5C%22%2C%5C%5C%5C%22id%5C%5C%5C%22%3Anull%2C%5C%5C%5C%22contentName%5C%5C%5C%22%3A%5C%5C%5C%22videoStoryMAI%5C%5C%5C%22%2C%5C%5C%5C%22blockRef%5C%5C%5C%22%3Anull%2C%5C%5C%5C%22containerIndex%5C%5C%5C%22%3A0%2C%5C%5C%5C%22accessibleItemCount%5C%5C%5C%22%3A0%2C%5C%5C%5C%22firstViewableIndex%5C%5C%5C%22%3A0%2C%5C%5C%5C%22lastViewableIndex%5C%5C%5C%22%3A0%2C%5C%5C%5C%22localContentId%5C%5C%5C%22%3Anull%2C%5C%5C%5C%22reasonType%5C%5C%5C%22%3Anull%2C%5C%5C%5C%22selected%5C%5C%5C%22%3Anull%2C%5C%5C%5C%22filter%5C%5C%5C%22%3Anull%7D%5C%22%7D%22%2C%22blockRef%22%3Anull%2C%22refMarker%22%3A%22dmm_aud_pop_us_na_twice_oo_qr_vs%22%2C%22target%22%3Anull%2C%22localContentId%22%3Anull%7D&userHash=%7B%22level%22%3A%22FREE_MEMBER%22%7D',
                                                        clientInformation: [],
                                                        before: [],
                                                        after: [],
                                                        onSuccess: [],
                                                        onError: [],
                                                        queue: {
                                                            interface: 'QueuesInterface.v1_0.MultiThreadedQueue',
                                                            id: 'MT_HTTP',
                                                        },
                                                        forced: false,
                                                    },
                                                    {
                                                        interface: 'TemplateListInterface.v1_0.RemoveTemplateMethod',
                                                        queue: {
                                                            interface: 'QueuesInterface.v1_0.SingleThreadedQueue',
                                                            id: 'TEMPLATE',
                                                        },
                                                        forced: false,
                                                    },
                                                ],
                                            },
                                        },
                                        onCreated: [],
                                        onBound: [],
                                        onViewed: [],
                                        onInteraction: [],
                                        onLeave: [],
                                        launchMode: 'standard',
                                        cacheSeconds: 9223372036854775807,
                                    },
                                    screenMode: 'templateShard',
                                    queue: {
                                        interface: 'QueuesInterface.v1_0.SingleThreadedQueue',
                                        id: 'TEMPLATE',
                                    },
                                    forced: false,
                                },
                            ],
                        },
                    },
                    logo: 'https://m.media-amazon.com/images/G/01/music-tv/music_logo._SX260_SY50_BL0_QL100_FMpng_.png',
                    autoPlay: true,
                    onStarted: [],
                    onResumed: [],
                    onPaused: [],
                    onFinished: [],
                    onStopped: [],
                    onError: [],
                    onCreated: [],
                    onInteraction: [
                        {
                            interface: 'InteractionInterface.v1_0.GlobalInvokeHttpSkillMethod',
                            url: 'https://na.mesk.skill.music.a2z.com/api/elementClicked?info=%7B%22action%22%3A%22PLAY_PAUSE_VIDEO_STORY%22%2C%22pageType%22%3A%22NOW_PLAYING_VIDEO_STORY%22%2C%22interactionType%22%3Anull%2C%22metricsToken%22%3A%22%22%2C%22blockRef%22%3Anull%2C%22refMarker%22%3A%22%22%2C%22target%22%3Anull%2C%22localContentId%22%3Anull%7D&userHash=%7B%22level%22%3A%22FREE_MEMBER%22%7D',
                            clientInformation: [],
                            before: [],
                            after: [],
                            onSuccess: [],
                            onError: [],
                            queue: {
                                interface: 'QueuesInterface.v1_0.MultiThreadedQueue',
                                id: 'MT_HTTP',
                            },
                            forced: false,
                        },
                    ],
                    onLeave: [],
                    launchMode: 'standard',
                    cacheSeconds: 9223372036854775807,
                    onViewed: [
                        {
                            interface: SET_VIDEO_STORIES_MEDIA_EVENTS,
                            forced: false,
                            owner: 'me',
                            onNavigateToNext: [
                            // {
                            //     interface: SET_VIDEO_STORIES_INDEX,
                            //     currentTemplateIndex: 1,
                            //     forced: false,
                            //     owner: 'me',
                            // },
                            ],
                            onNavigateToPrevious: [
                                {
                                    interface: SET_VIDEO_STORIES_INDEX,
                                    currentTemplateIndex: 1,
                                    forced: false,
                                    owner: 'me',
                                    queue: {
                                        interface: 'QueuesInterface.v1_0.SingleThreadedQueue',
                                        id: 'TEMPLATE',
                                    },
                                },
                            ],
                            onClose: [
                            // {
                            //     interface: REMOVE_TEMPLATE,
                            //     forced: false,
                            //     owner: 'me',
                            // }
                            ],
                            queue: {
                                interface: 'QueuesInterface.v1_0.MultiThreadedQueue',
                                id: 'MT_HTTP',
                            },
                        },
                    ],
                },
            ],
            queue: {
                interface: 'QueuesInterface.v1_0.SingleThreadedQueue',
                id: 'TEMPLATE',
            },
            forced: false,
            owner: 'me',
        },
        {
            interface: SET_VIDEO_STORIES_MEDIA_EVENTS,
            onCreated: [
                {
                    interface: 'PlaybackInterface.v1_0.PauseMediaMethod',
                    queue: {
                        interface: 'QueuesInterface.v1_0.SingleThreadedQueue',
                        id: 'PLAYBACK',
                    },
                    forced: false,
                    owner: 'me',
                },
            ],
            onClose: [
                {
                    interface: REMOVE_TEMPLATE,
                    queue: {
                        interface: 'QueuesInterface.v1_0.SingleThreadedQueue',
                        id: 'PLAYBACK',
                    },
                    forced: false,
                    owner: 'me',
                },
            ],
            forced: false,
            owner: 'me',
            queue: {
                interface: 'QueuesInterface.v1_0.SingleThreadedQueue',
                id: 'TEMPLATE',
            },
        },
    ];
}
function getInitialRequestMethod(owner, methods, softRefresh = false) {
    return {
        interface: CREATE_TEMPLATE,
        forced: false,
        owner,
        queue: {
            interface: 'QueuesInterface.v1_0.SingleThreadedQueue',
            id: 'TEMPLATE',
        },
        template: {
            interface: CHROME_TEMPLATE,
            templateData: { title: 'Amazon Music', deeplink: getInitialPath() },
            innerTemplate: {},
            launchMode: 'standard',
            menuItems: [],
            onCreated: methods.length > 0
                ? methods
                : [
                    {
                        interface: 'InteractionInterface.v1_0.InvokeHttpSkillMethod',
                        url: getStartupUrl(undefined, softRefresh),
                        queue: {
                            interface: 'QueuesInterface.v1_0.MultiThreadedQueue',
                            id: 'MT_HTTP',
                        },
                        before: [],
                        after: [],
                        onError: [getGenericErrorDialogMethod()],
                    },
                ],
        },
    };
}
function getInitialPath() {
    const parser = globals.document.createElement('a');
    parser.href = globals.location.href;
    const initialPath = parser.pathname;
    // to correct deeplink for retail player with URL - */dp/<asin>
    if (isRetailPlayerRequest(globals.location.hostname) &&
        RETAIL_PLAYER_DP_ASIN_REGEX_PATH.test(initialPath)) {
        return initialPath.replace(RETAIL_PLAYER_DP_ASIN_REGEX_REPLACE, '/dp/');
    }
    // to correct deeplinks for retail player with URL - https://<retail_domain>/music/player/<deeplink_path>
    return initialPath.replace(RETAIL_PLAYER_PATH_SUBSTR_REGEX_EXP, '/');
}
export function addQueryParams(initialPath, allowedQueryParams) {
    let url = initialPath;
    for (const queryParam of allowedQueryParams) {
        // We need to recalculate the sep because we may have used earlier.
        const sep = url.includes('?') ? '&' : '?';
        const queryParameterValue = getParameterByName(queryParam, globals.location.href);
        if (queryParameterValue) {
            url += `${sep + queryParam}=${queryParameterValue}`;
        }
    }
    return url;
}
export function hasQueryParams(allowedQueryParams) {
    for (const queryParam of allowedQueryParams) {
        const queryParamValue = getParameterByName(queryParam, globals.location.href);
        if (queryParamValue) {
            return true;
        }
    }
    return false;
}
function getStartupUrl(url, softRefresh) {
    var _a, _b;
    const STARTUP_PATH = '/api/showHome';
    const skyfireEnvironment = getSkyfireEnvironment();
    const startupUrl = url || skyfireEnvironment + STARTUP_PATH;
    const initialPath = getInitialPath();
    const allowedQueryParams = new Set([
        'trackAsin',
        'storyAsin',
        'do',
        'tag',
        'category',
        'experienceId',
        'sequence',
        'name',
        'paymentPlanId',
        'fromAPX',
        'orderId',
        'executionStatus',
        'reason',
        'story',
        'viewType',
    ]);
    if (!initialPath ||
        ((initialPath === '/' || initialPath === '/home') && !hasQueryParams(allowedQueryParams))) {
        if (softRefresh) {
            return `${startupUrl}?softRefresh=true`;
        }
        return startupUrl;
    }
    const deeplinkQueryParam = JSON.stringify(getIDeeplinkClientInformation(addQueryParams(initialPath, allowedQueryParams)));
    const sep = startupUrl.includes('?') ? '&' : '?';
    let currentUrl = `${startupUrl + sep}deeplink=${encodeURIComponent(deeplinkQueryParam)}`;
    if (softRefresh) {
        currentUrl += '&softRefresh=true';
    }
    if (((_b = (_a = getState(PathChangedEvent)) === null || _a === void 0 ? void 0 : _a.activeApp) !== null && _b !== void 0 ? _b : AppName.WEBFIRE) !== AppName.WEBFIRE) {
        currentUrl += '&skeletonResponse=true';
    }
    return currentUrl;
}
function getIDeeplinkClientInformation(deeplink) {
    return {
        interface: 'DeeplinkInterface.v1_0.DeeplinkClientInformation',
        deeplink,
    };
}
export function initSkyfire(store, owner = 'BOOTSTRAP', softRefresh = false) {
    const { dispatch } = store;
    const { deviceId } = store.getState().Authentication;
    const env = getParameterByName('skyfireEnv', globals.location.href);
    const onStartMethods = JSON.parse(globals.localStorage.getItem(`${deviceId}_${env}_onStart`) || '[]').map((method) => {
        const newMethod = Object.assign(Object.assign({}, method), { url: getStartupUrl(method.url, softRefresh) });
        return newMethod;
    });
    // comment this out to test frontend
    const initialRequest = getInitialRequestMethod(owner, onStartMethods, softRefresh);
    dispatch(enqueueSkyfireMethod({ queue: initialRequest.queue, method: initialRequest }));
    // hard-coded frontend for testing
    // const test = getVideoStoriesMediaForVideoStoriesSkill();
    // test.forEach((method) => {
    //     dispatch(enqueueSkyfireMethod({ queue: method.queue, method }));
    // });
}
